import { render, staticRenderFns } from "./landing-nav-footer.vue?vue&type=template&id=2ce1ef4a"
import script from "./landing-nav-footer.vue?vue&type=script&lang=js"
export * from "./landing-nav-footer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports